"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginDefinition_1 = require("auto-widget-framework/src/Plugin/PluginDefinition");
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
class FormHandlerPluginDefinition extends PluginDefinition_1.default {
    /**
     * @inheritDoc
     */
    constructor(definition) {
        super(definition);
        if (definition.extensions) {
            if (!Array.isArray(definition.extensions)) {
                throw new WidgetError_1.default(`Form extensions expected in format of array for "${this.id}" form handler.`);
            }
            this.extensions = definition.extensions;
        }
    }
    /**
     * @inheritDoc
     */
    static getType() {
        return "form_handler";
    }
    /**
     * Gets the form extension plugin IDs.
     *
     * @return {string[]}
     */
    getExtensions() {
        return this.extensions || [];
    }
}
exports.default = FormHandlerPluginDefinition;
